module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"36\" height=\"36\"><g fill=\"none\" fill-rule=\"evenodd\"><circle cx=\"18\" cy=\"18\" r=\"18\" fill=\"#5A5AE6\"></circle><path fill=\"#FFF\" d=\"M23.9 27.27a3.92 3.92 0 0 1-3.44-2.02l-.01-.02-.02-.02-6.52-11.74a3.93 3.93 0 0 1 6.86-3.81l.02.02.01.02 6.52 11.74a3.93 3.93 0 0 1-3.43 5.83zm-11.8 0a3.93 3.93 0 1 1 0-7.85 3.93 3.93 0 0 1 0 7.85z\"></path></g></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/components/ui/logo/svg/logo.svg
// module id = 565
// module chunks = 0